(async function (global) {
    if (!global) return
    global.gptInfo = {}
    function showLoading(dom) {
        var head = document.head || document.getElementsByTagName('head')[0];
        var style = document.createElement('style');
        var css = `
            #chat_gpt_loading {
                display: none;
                position: absolute;
                top: 50%;
                left: 50%;
                width: 50px;
                height: 50px;
                margin-top: -25px;
                margin-left: -25px;
                border: 5px solid #fff;
                border-top-color: #4CAF50;
                border-radius: 50%;
                animation: spin 1s ease-in-out infinite;
            }
            @keyframes spin {
                to { transform: rotate(360deg); }
            }
            @media screen and (max-width: 768px) {
                #chat_gpt_modal .chat_gpt_modal_content{
                    width: 100%!important;
                    height: 100%!important;
                    padding-bottom: 54px;
                    border-radius: 0!important;
                }
                #chat_gpt_modal .chat_gpt_modal_content > svg{
                    left: unset!important;
                    right: 14px;
                    top: 28px!important;
                    z-index: 99999999;
                }
            }
        `;
        style.appendChild(document.createTextNode(css));
        head.appendChild(style);
        var loading = document.createElement('div');
        loading.setAttribute('id', 'chat_gpt_loading');
        loading.style.display = 'block';
        dom.appendChild(loading);
    }
    function httpGet(url) {
        return new Promise((resolve) => {
            let xmlhttp = new XMLHttpRequest();
            xmlhttp.open('GET', url, true);
            xmlhttp.send();
            xmlhttp.onreadystatechange = function () {
                if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
                    try {
                        let response = JSON.parse(xmlhttp.response);
                        if (response) {
                            resolve(response)
                        } else {
                            console.info("XMLHttpRequest创建失败");
                            resolve({})
                        }
                    } catch (err) {
                        console.error(err)
                        resolve({})
                    }
                } else if (xmlhttp.readyState == 4 && xmlhttp.status != 200) {
                    console.info("网络错误，请稍后重试");
                    resolve({})
                }
            }
        })
    }
    // 添加检查函数
    function isInIframeWithParentInit() {
        try {
            return window !== window.top && window.top.global && window.top.global.gptInfo;
        } catch (e) {
            return false;
        }
    }
    // 在初始化之前添加检查
    if (!isInIframeWithParentInit()) {
        global.gptInfo = {}
        //校验登陆后才展示
        let loginRes = await httpGet('/learn/login/info')
        if (!loginRes || !loginRes.data || !loginRes.data.userInfo || !loginRes.data.userInfo.user_code) {
            try {
                // 尝试从父窗口获取登录状态
                if (window !== window.top && window.top.global && window.top.global.userInfo) {
                    loginRes = { data: { userInfo: window.top.global.userInfo } };
                } else {
                    return;
                }
            } catch (e) {
                return;
            }
        }

        //小程序不要chatgpt
        function getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) { return pair[1]; }
            }
            return (false);
        }
        var cookie = getQueryVariable('cookie');
        if (cookie) return
        const closePathData = "M801.645714 170.666667l51.833905 51.590095L565.150476 511.951238l288.353524 289.670095-51.833905 51.614477-288.109714-289.450667L225.426286 853.23581 173.592381 801.621333l288.329143-289.670095L173.592381 222.256762 225.426286 170.666667l288.109714 289.426285L801.645714 170.666667z"
        let btnDom = document.createElement("div")
        btnDom.setAttribute('id', 'chat_gpt_btn')
        let btnStyles = {
            position: 'fixed',
            right: 0,
            bottom: '20vh',
            width: '60px',
            height: '60px',
            lineHeight: '60px',
            borderRadius: '50%',
            textAlign: 'center',
            cursor: 'pointer',
            zIndex: 9999,
            overflow: 'hidden',
            display: 'none',
            boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 1px 2px'
        }
        Object.keys(btnStyles).map(key => {
            btnDom.style[key] = btnStyles[key]
        })
        document.body.appendChild(btnDom)
        //弹框内容区域
        let modalContentDom = document.createElement('div')
        styles = {
            width: '629px',
            height: '100%',
            position: 'fixed',
            bottom: 0,
            right: '0',
            borderRadius: '6px 0 0 6px',
            boxShadow: '50px 50px 100px 10px rgba(0,0,0,.1)',
            overflow: 'hidden',
            backgroundColor: '#fff',
        }
        Object.keys(styles).map(key => {
            modalContentDom.style[key] = styles[key]
        })
        modalContentDom.setAttribute('class', 'chat_gpt_modal_content')
        btnDom.onclick = function (e) {
            if (isDrag) return
            if (document.getElementById('chat_gpt_modal')) {
                //移除重新加载
                document.getElementById('chat_gpt_modal').remove()
                // document.getElementById('chat_gpt_modal').style.display = 'block'
                // return
            }
            //弹窗
            let madalDom = document.createElement('div')
            let styles = {
                width: '100%',
                height: '100%',
                position: 'fixed',
                top: '0',
                left: '0',
                borderRadius: '4px',
                backgroundColor: 'rgba(0,0,0,.2)',
                zIndex: 9999,
            }
            Object.keys(styles).map(key => {
                madalDom.style[key] = styles[key]
            })
            madalDom.setAttribute('id', 'chat_gpt_modal')
            //遮罩
            let modalMaskDom = document.createElement('div')
            styles = {
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: '0',
                left: '0',
            }
            Object.keys(styles).map(key => {
                modalMaskDom.style[key] = styles[key]
            })
            modalMaskDom.onclick = function () {
                if (document.getElementById('chat_gpt_modal')) {
                    document.getElementById('chat_gpt_modal').style.display = 'none'
                }
            }
            //关闭按钮
            let modalCloseSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
            let iconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path')
            iconPath.setAttribute('d', closePathData)
            modalCloseSvg.setAttribute("width", "200");
            modalCloseSvg.setAttribute("height", "200");
            modalCloseSvg.setAttribute("x", "0");
            modalCloseSvg.setAttribute("y", "0");
            modalCloseSvg.setAttribute("fill", "#303030");
            modalCloseSvg.setAttribute("viewBox", "0 0 1024 1024");
            modalCloseSvg.style.width = '20px'
            modalCloseSvg.style.height = '20px'
            modalCloseSvg.style.display = 'block'
            styles = {
                width: '20px',
                height: '40px',
                position: 'absolute',
                top: '50%',
                right: '-20px',
                display: 'none'
            }
            Object.keys(styles).map(key => {
                modalCloseSvg.style[key] = styles[key]
            })
            modalCloseSvg.appendChild(iconPath)
            modalCloseSvg.onclick = function () {
                if (document.getElementById('chat_gpt_modal')) {
                    document.getElementById('chat_gpt_modal').style.display = 'none'
                }
            }
            //iframe
            global.chatGptIframe = document.createElement('iframe')
            styles = {
                width: '100%',
                height: '100%',
                border: 'none',
            }
            Object.keys(styles).map(key => {
                global.chatGptIframe.style[key] = styles[key]
            })
            global.chatGptIframe.setAttribute('src', `/terminator/smart/chat?id=${global.gptInfo.currentGpt.id || ''}&courseId=${global.gptInfo.course_id || ''}&question=${global.gptInfo.currentGpt.initQuestion || ''}`)
            showLoading(modalContentDom)
            global.chatGptIframe.onload = function () {
                //iframe加载完成
                modalContentDom.removeChild(document.getElementById('chat_gpt_loading'))
            }
            modalContentDom.appendChild(modalCloseSvg)
            modalContentDom.appendChild(global.chatGptIframe)
            madalDom.appendChild(modalMaskDom)
            madalDom.appendChild(modalContentDom)
            document.body.appendChild(madalDom)
        }//按钮可拖动
        let isDrag = false
        btnDom.onmousedown = function (e) { // 元素大小
            let ms = new Date().getTime();
            let elW = e.currentTarget.offsetWidth;
            let elH = e.currentTarget.offsetHeight;
            // 元素位置
            let elL = e.currentTarget.offsetLeft;
            let elT = e.currentTarget.offsetTop;
            // 鼠标位置
            let x = e.clientX;
            let y = e.clientY;
            // 窗口大小
            let w = window.innerWidth;
            let h = window.innerHeight;
            // 鼠标到元素左边距离
            let moveX = x - elL;
            let moveY = y - elT;
            let el = e.currentTarget;
            document.onmousemove = function (e) {
                isDrag = true;
                let right = w - (e.clientX - moveX) - elW;
                let bottom = h - (e.clientY - moveY) - elH;
                // 限制右边和底部的位置不能超出窗口的可视范围
                if (right < 0) {
                    right = 0;
                } else if (right > w - elW) {
                    right = w - elW;
                }
                if (bottom < 0) {
                    bottom = 0;
                } else if (bottom > h - elH) {
                    bottom = h - elH;
                }
                el.style.right = right + 'px';
                el.style.bottom = bottom + 'px';
            };
            document.onmouseup = function (e) {
                if (new Date().getTime() - ms < 300) {
                    isDrag = false;
                    btnDom.click();
                }
                document.onmousemove = null;
                document.onmouseup = null;

            // 左右自动吸附
            let right = w - (e.clientX - moveX) - elW;
            const distance = w / 2; // 定义距离窗口边缘的距离
            if (right < distance) {
                right = 0;
                el.style.right = right + 'px';
            } else if ((w - right - elW) < distance) {
                right = w - elW;
                el.style.right = right + 'px';
            }

                setTimeout(() => {
                    isDrag = false;
                }, 300);
            };
        }
        btnDom.addEventListener('touchstart', function (e) {
            e.preventDefault();
            let elW = e.currentTarget.offsetWidth;
            let elH = e.currentTarget.offsetHeight;
            let elL = e.currentTarget.offsetLeft;
            let elT = e.currentTarget.offsetTop;
            let x = e.touches[0].clientX;
            let y = e.touches[0].clientY;
            let w = window.innerWidth;
            let h = window.innerHeight;
            let moveX = x - elL;
            let moveY = y - elT;
            let offsetX = 0;
            let offsetY = 0;
            let el = e.currentTarget;
            let ms = new Date().getTime();

            btnDom.addEventListener('touchmove', function (e) {
                offsetX = e.touches[0].clientX - moveX;
                offsetY = e.touches[0].clientY - moveY;

            if (offsetX < 0) {
                offsetX = 0;
            }
            if (offsetX > w - elW) {
                offsetX = w - elW;
            }
            if (offsetY < 0) {
                offsetY = 0;
            }
            if (offsetY > h - elH) {
                offsetY = h - elH;
            }

                el.style.right = w - offsetX - elW + 'px';
                el.style.bottom = h - offsetY - elH + 'px';
            });

            btnDom.addEventListener('touchend', function (e) {
                if (new Date().getTime() - ms < 300) {
                    btnDom.click();
                }
                offsetX = e.changedTouches[0].clientX - moveX;
                offsetY = e.changedTouches[0].clientY - moveY;

                if (offsetX < 0) {
                    offsetX = 0;
                }
                if (offsetX > w - elW) {
                    offsetX = w - elW;
                }
                if (offsetY < 0) {
                    offsetY = 0;
                }
                if (offsetY > h - elH) {
                    offsetY = h - elH;
                }

                // 左右自动吸附
                const distance = w / 2; // 定义距离窗口边缘的距离
                if (offsetX < distance) {
                    offsetX = 0;
                } else if ((w - offsetX - elW) < distance) {
                    offsetX = w - elW;
                }

                el.style.right = w - offsetX - elW + 'px';
                el.style.bottom = h - offsetY - elH + 'px';
            });
        });
        /**
         * @param {*} assistant_id agentId
         * @param {*} course_id 课程id
         */
        global.setChatGptUrl = function ({ course_id }) {
            if (course_id) {
                global.gptInfo.course_id = course_id
            }
            // if (!assistant_id || !course_id) return
            // global.globalGptUrl = '/terminator/smart/chat?id=' + assistant_id + '&course_id=' + course_id
            // httpGet('/terminator/api/v1/application/aitools?page=1&page_size=999&id=' + assistant_id).then(res => {
            //     if (res.error_code == 'sc-terminator-service.0000.0000' && res.extend_message && res.extend_message.total) {
            //         let current = res.extend_message.records[0]
            //         let logo = current.icon || '/learn/static/imgs/chat_gpt_modal/default-avatar.png'
            //         btnDom.innerHTML = `<img src="${logo}" style="width: 100%;height: 100%;border-radius: 50%;-webkit-user-drag: none;">`
            //         btnDom.style.display = 'block'
            //         btnDom.style.opacity = 1
            //     }
            // })
        }
        const event = new CustomEvent('onLoadChatGpt')
        window.dispatchEvent(event)
        window.addEventListener('message', function (event) {
            if (event.data && modalContentDom) {
                try {
                    const { fullScreenState } = JSON.parse(event.data)
                    if (fullScreenState) {
                        modalContentDom.style.height = '100%'
                    } else {
                        modalContentDom.style.height = '50%'
                    }
                } catch { }
            }
        })
        try {
            setTimeout(() => {
                const { course_id } = global.gptInfo ?? {}
                httpGet(`/terminator/api/v1/application/aitools?page=1&page_size=999&course_id=${course_id || ''}`).then(res => {
                    if (res.error_code == 'sc-terminator-service.0000.0000' && res.extend_message && res.extend_message.total) {
                        let current = res.extend_message.records.find(item => item.current_course === true)
                        if (!course_id || !current) current = res.extend_message.records[0]
                        global.gptInfo.currentGpt = current
                        let img = document.createElement('img')
                        img.src = current.icon || (current.agent_type == 2 ? '/learn/static/imgs/agent/zhujiao.png' : current.agent_type == 3 ? '/learn/static/imgs/agent/xueban.png' : '/learn/static/imgs/agent/common.png')
                        btnDom.appendChild(img)
                        img.style.width = '100%'
                        img.style.height = '100%'
                        img.style.objectFit = 'cover'
                        img.style.pointerEvents = 'none'
                        btnDom.style.display = 'block'
                    }
                })
            }, 1000);
        } catch { }
    } else {
        console.log('ChatGPT modal already initialized in parent window');
    }
})(window)